import { Modal } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import Upload from './Upload'

export default function UploadModal({ opened, onClose, ...rest }) {
    const isMobile = useMediaQuery('(max-width: 50em)')

    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title="Upload Music"
            size="xl"
            fullScreen={isMobile}
            {...rest}
            styles={{
                title: {
                    fontSize: '1.125rem',
                    fontWeight: 700,
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                },
                body: {
                    padding: 0,
                    height: isMobile ? '100%' : 'auto',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
        >
            <Upload />
        </Modal>
    )
}

